import { TRUST_PILLARS } from '@/content/site-content';

/**
 * "Built on Trust, From Day One" — the three promises that hold at launch.
 *
 * It keeps the `#safety` anchor the rest of the app already links to.
 */
export function SafetySection() {
  return (
    <section id="safety" className="scroll-mt-28 bg-canvas py-16 lg:py-20">
      <div className="container-page">
        <h2 className="text-center text-3xl font-extrabold sm:text-4xl">
          Built on <span className="text-brand-600">Trust,</span> From Day One
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-center text-sm leading-relaxed text-ink-soft sm:text-base">
          We&rsquo;re a founding community - here&rsquo;s what you can count on, right from launch.
        </p>

        <ul className="mt-12 grid gap-6 lg:grid-cols-3">
          {TRUST_PILLARS.map((pillar) => (
            <li key={pillar.title} className={`rounded-[1.25rem] border p-6 ${pillar.surface}`}>
              <span
                className={`grid size-11 place-items-center rounded-xl ${pillar.chip}`}
                aria-hidden="true"
              >
                <pillar.icon className="size-5" />
              </span>
              <h3 className="mt-5 text-lg font-bold text-ink">{pillar.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-ink-soft">{pillar.description}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
